<!------------------------------------------------------------------------------
 File: BaseIcon 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 17/10/2018
 Time: 16:12
------------------------------------------------------------------------------->
<template>
    <component
        :is="tag_name"
        :class="cls">
        <slot></slot>
        {{content}}</component>
</template>

<script>
    export default {
        name: 'BaseIcon',
        components: {},
        props: {
            content: {
                type: String,
                default: ''
            },
            cls: {
                type: String,
                default: 'material-icons'
            },
            tag_name:{
                type: String,
                default: 'i'
            }
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/base/BaseIcon.vue?83d39a9a